import { array, string, arrayOf, oneOfType } from 'prop-types';

const roleSelector = (tokenObject, apiRoles, fallbackUserRole) => {
	if (Array.isArray(tokenObject)) {
		return tokenObject;
	}
	if (apiRoles.includes(tokenObject)) {
		return [tokenObject];
	}
	return [fallbackUserRole];
};

roleSelector.propTypes = {
	tokenOjbect: oneOfType([string, array]).isRequired,
	apiRoles: arrayOf(string),
	fallbackUserRole: string
};

roleSelector.defaultProps = {
	apiRoles: [],
	fallbackUserRole: ''
};

export default roleSelector;
